const STOCK_BASE = 'https://static.shopmy.us/Webinars';

export const WEBINAR_STOCK_BACKGROUNDS = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  url: `${STOCK_BASE}/Background${i + 1}.jpg`
}));
